/**
 * @generated SignedSource<<d358ceadd5091e05ce1fa526ef4494bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobStepLastRunFragment$data = {
  readonly rawId: number | null;
  readonly status: string | null;
  readonly " $fragmentType": "JobStepLastRunFragment";
};
export type JobStepLastRunFragment$key = {
  readonly " $data"?: JobStepLastRunFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobStepLastRunFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobStepLastRunFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "1c187c674f1d6abca2adfa5b8caced9f";

export default node;
